(function () {
  function init(root) {
    if (!root || root.dataset.homeInitialized === 'true') return;
    root.dataset.homeInitialized = 'true';
(() => {
          const section = root.querySelector('.home-program-teaser');
          const viewportElement = section?.querySelector('.home-program-teaser__viewport');
          const track = section?.querySelector('.home-program-teaser__inner');
          if (!section || !viewportElement || !track) return;

          const clamp = (value, min = 0, max = 1) => Math.min(max, Math.max(min, value));
          const smooth = (from, to, value) => {
            const progress = clamp((value - from) / Math.max(0.001, to - from));
            return progress * progress * (3 - 2 * progress);
          };
          const items = [...section.querySelectorAll('.home-program-scene')];
          if (items.length !== 4) return;
          let initialCenter = 0;
          let segmentDistance = 0;
          let scrollDistance = 1;
          let observer;
          let frameId;
          let destroyed = false;

           function measure() {
             const viewportHeight = viewportElement.clientHeight;
             if (!Number.isFinite(viewportHeight) || viewportHeight <= 0) return;
             const compactViewport = window.matchMedia('(max-width: 69.9375rem)').matches;
             initialCenter = viewportHeight * (compactViewport ? 0.32 : 0.58);
            const measuredSeparation = items.slice(0, -1).reduce((maximum, item, index) => {
              const adjacentHalfHeights = (item.offsetHeight + items[index + 1].offsetHeight) / 2;
              return Math.max(maximum, adjacentHalfHeights + viewportHeight * 0.08);
            }, 0);
            const nextSegmentDistance = Math.max(viewportHeight * 0.69, measuredSeparation);
            segmentDistance = Number.isFinite(nextSegmentDistance) && nextSegmentDistance > 0
              ? nextSegmentDistance
              : viewportHeight * 0.69;
             const finalFadeOutCenter = viewportHeight * (compactViewport ? 0.72 : 0.13);
            const nextScrollDistance = initialCenter + (items.length - 1) * segmentDistance - finalFadeOutCenter;
            scrollDistance = Number.isFinite(nextScrollDistance) && nextScrollDistance > 0
              ? nextScrollDistance
              : viewportHeight * items.length;
            section.style.setProperty('--home-program-scroll-height', `${viewportHeight + scrollDistance}px`);
          }

          function update() {
            const rect = section.getBoundingClientRect();
            const viewportHeight = viewportElement.clientHeight;
            const distance = clamp(-rect.top, 0, scrollDistance);
            items.forEach((item, index) => {
              const centerY = initialCenter + index * segmentDistance - distance;
              const topOpacity = smooth(viewportHeight * 0.13, viewportHeight * 0.29, centerY);
              const bottomOpacity = 1 - smooth(viewportHeight * 0.72, viewportHeight * 0.94, centerY);
              item.style.setProperty('--home-program-item-y', `${centerY.toFixed(2)}px`);
              item.style.setProperty('--home-program-item-opacity', Math.min(topOpacity, bottomOpacity).toFixed(3));
            });
          }

          let ticking = false;
          function requestUpdate() {
            if (ticking) return;
            ticking = true;
            frameId = requestAnimationFrame(() => {
              if (destroyed) return;
              section.classList.add('home-is-program-active');
              update();
              ticking = false;
            });
          }

          if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
            return;
          }
          section.classList.add('home-is-program-active');
          measure();
          update();
          document.fonts?.ready.then(() => {
            if (destroyed) return;
            measure();
            requestUpdate();
          });
          window.addEventListener('scroll', requestUpdate, { passive: true });
          function handleResize() {
            measure();
            requestUpdate();
          }
          window.addEventListener('resize', handleResize);
          if ('ResizeObserver' in window) {
            observer = new ResizeObserver(() => {
              measure();
              requestUpdate();
            });
            items.forEach((item) => observer.observe(item));
          }
          root.homeCleanup = () => {
            if (destroyed) return;
            destroyed = true;
            window.removeEventListener('scroll', requestUpdate);
            window.removeEventListener('resize', handleResize);
            observer?.disconnect();
            if (frameId) cancelAnimationFrame(frameId);
            delete root.dataset.homeInitialized;
            delete root.homeCleanup;
          };
        })();

  }
  const currentScript = document.currentScript;
  const section = currentScript?.closest('.shopify-section');
  init(section?.querySelector('[data-home-authoritative]'));
  const handleSectionLoad = function (event) {
    init(event.target?.querySelector?.('[data-home-authoritative]'));
  };
  const handleSectionUnload = function (event) {
    const root = event.target?.querySelector?.('[data-home-authoritative]');
    root?.homeCleanup?.();
    if (root) delete root.dataset.homeInitialized;
  };
  const previousLifecycle = window.__homeProgramLifecycle;
  if (previousLifecycle) {
    document.removeEventListener('shopify:section:load', previousLifecycle.load);
    document.removeEventListener('shopify:section:unload', previousLifecycle.unload);
  }
  window.__homeProgramLifecycle = { load: handleSectionLoad, unload: handleSectionUnload };
  document.addEventListener('shopify:section:load', handleSectionLoad);
  document.addEventListener('shopify:section:unload', handleSectionUnload);
}());
